/** Copyright © 2013-2025 DataYes, All Rights Reserved. */

import styled from 'styled-components';

export const StylePageBase = styled.div`
  width: 1420px;
  margin: 10px auto 20px;
  padding-left: 176px;
  font-size: 12px;

  @media screen and (max-width: 1400px) {
    width: 1280px;
  }
  @media screen and (max-width: 1300px) {
    width: 1180px;
  }

  > .content {
    position: relative;
    width: 100%;
    min-height: 670px;
  }
`;
